import { ensureJobCorn } from '@eigtech/restoration-util'
import { withRequiredPermissions } from '@/lib/permissions'
import { UploadMeetingVideo } from '@eigtech/ui-shared-meetings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/meetings_/new-from-upload')({
  component: () => <Page />,
})

function JobDetailCreateMeetingFromVideo() {
  const { jobId } = Route.useParams()

  return <UploadMeetingVideo entityId={ensureJobCorn(jobId)} />
}

const Page = withRequiredPermissions(JobDetailCreateMeetingFromVideo, {
  requiredPermissions: [{ action: 'create', subject: 'meeting' }],
})
